function ResponsiveBackgroundImage() {
	var self = this;
	this.elements = [];
	this.init();
}

ResponsiveBackgroundImage.prototype.init = function() {
	var self = this;
	$('.responsive-background').each(function() {
		$(this).addClass('-loading');
		self.bindElement($(this).find('img:not(.lazy)'));
	});
};

ResponsiveBackgroundImage.prototype.bindElement = function(selector) {
	var self = this;
	$(selector).on('load', self.update.bind($(selector)));
	setTimeout(function() {
		$(selector).attr('src', $(selector).attr('src'));
	}, 250);
};

ResponsiveBackgroundImage.prototype.update = function(element) {
	var that = this;
	var src = typeof that.get(0).currentSrc !== 'undefined' ? that.get(0).currentSrc : that.get(0).src;
    if (src && src != that.src) {
    	that.closest('.responsive-background').css('background-image', 'url("'+src+'")').addClass('-loaded');
    }
};

